module.exports = __webpack_public_path__ + "static/img/101262.2dcd4c38.png";